export default __webpack_public_path__ + "static/media/google.952443d7.svg";